/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './defs.defs.js'

const $nsid = 'com.atproto.label.queryLabels'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 250, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  sources: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
  ),
  uriPatterns: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  labels: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Find labels relevant to the provided AT-URI patterns. Public endpoint for moderation services, though may return different or additional results with auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
